import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { Practitioner } from 'src/app/shared/models/practitioner.model';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ModalNotificationComponent } from 'src/app/shared/components/modal-notification/modal-notification.component';

@Component({
  selector: 'app-practitioner-list-item',
  templateUrl: './practitioner-list-item.component.html',
  styleUrls: ['./practitioner-list-item.component.scss']
})
export class PractitionerListItemComponent implements OnInit {
  @Input() practitioner: Practitioner;
  @Input() distance: string;
  @Input() matchedTerms: string[];
  @Input() active: boolean;
  @ViewChild('confirmation') confirmationModal: ModalNotificationComponent;
  currentWindowWidth: number;

  get isMobileScreen(): boolean {
    return this.currentWindowWidth <= 420;
  }

  constructor(private toastService: ToastService) { }

  ngOnInit(): void {
    this.currentWindowWidth = window.innerWidth;
  }

  onSharePractitioner() {
    let listener = (e: ClipboardEvent) => {
      let clipboard = e.clipboardData || window['clipboardData'];
      clipboard.setData('text', environment.webUrl + 'practitioner/' + this.practitioner.id);
      e.preventDefault();
      this.toastService.show('Practitioner link copied to clipboard.', { classname: 'zaya-toast', delay: 3000 });
    };
    document.addEventListener('copy', listener, false)
    document.execCommand('copy');
    document.removeEventListener('copy', listener, false);
  }

  openConfirmation(): void {
    this.confirmationModal.open('Thank you!', 'Someone will contact you shortly.', 'Okay');
  }

  @HostListener('window:resize')
  onResize() {
    this.currentWindowWidth = window.innerWidth;
  }
}
